// removed by extract-text-webpack-plugin
module.exports = {"container":"_94wtCbdsOI6GmrObeqze"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Auth/Logo/styles.css
// module id = 1233
// module chunks = 85